import { Route } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { ViewOneComponent } from './pages/view-one/view-one.component';
import { CustomerDetailsComponent } from './pages/customer-details/customer-details.component';
import { CheckoutPageComponent } from './pages/checkout-page/checkout-page.component';
import { ShoppingCartComponent } from './components/shopping-cart/shopping-cart.component';
import { OrderConfirmationComponent } from './pages/order-confirmation/order-confirmation.component';
import { ViewPastTicketsComponent } from './pages/view-past-tickets/view-past-tickets.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { HobbsTechsolutelyComponent } from './pages/hobbs-techsolutely/hobbs-techsolutely.component';
// TODO: Uncomment when wishlist functionality is finalized
// import { WishlistComponent } from './pages/wishlist/wishlist.component';
import { authGuard, LoginWithEmailComponent } from '@hypenation/auth';
import { RsvpPageComponent } from './pages/rsvp-page/rsvp-page.component';
import { WalletTopUpComponent } from './pages/wallet-top-up/wallet-top-up.component';

// Shared routes that can be reused across apps (cart, checkout, view-one, etc.)
export const sharedTicketRoutes: Route[] = [
  {
    path: 'rsvp/:token',
    component: RsvpPageComponent,
  },
  {
    path: 'cart/:uuid',
    component: ShoppingCartComponent,
  },
  {
    path: 'checkout/:orderNumber',
    component: CheckoutPageComponent,
  },
  {
    path: 'tickets/:slug/:uuid/:eventTypeUid',
    component: ViewOneComponent,
  },
  {
    path: 'tickets/:slug/:token',
    component: ViewOneComponent,
  },
  {
    path: 'customer-details',
    component: CustomerDetailsComponent,
  },
  {
    path: 'order-confirmation/:orderNumber',
    component: OrderConfirmationComponent,
  },
  {
    path: 'wallet-top-up',
    component: WalletTopUpComponent,
  },
  {
    // Gateway return target for wallet-top-up payments. Deliberately a plain
    // path (no route/query params) — see WalletTopUpComponent for why.
    path: 'wallet-top-up/confirmation',
    component: WalletTopUpComponent,
    data: { mode: 'confirmation' },
  },
  {
    path: 'previous-orders',
    component: ViewPastTicketsComponent,
    canActivate: [authGuard],
  },
  // TODO: Uncomment when wishlist functionality is finalized
  // {
  //   path: 'wishlist',
  //   component: WishlistComponent,
  //   canActivate: [authGuard],
  // },
  {
    path: 'terms-conditions',
    component: TermsAndConditionsComponent,
  },
  {
    path: 'hobbsTechsolutely',
    component: HobbsTechsolutelyComponent,
  },
];

// Full routes for ticketing app (includes home page)
export const appRoutes: Route[] = [
  {
    path: 'tickets',
    component: HomePageComponent,
  },
  {
    path: 'login',
    component: LoginWithEmailComponent,
  },
  ...sharedTicketRoutes,
  { path: '**', redirectTo: '/tickets', pathMatch: 'full' },
];
